import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash"
import {PlanningCommonService} from "../../services/planning-coomon-service.service";

export class PlanningJobsActionButtonCtrl implements IController {
  isDraft?: boolean;
  isDisabled?: boolean;
  jobs: any;
  selectedIds: any;
  onCreateRoute: Function;
  onAssignToRoute: Function;
  onAddToDraft: Function;
  onRemove: Function;
  onMoveToLeftovers: Function;
  onToggleLockJobs: Function;

  public blockedJobsIds: string[];
  private actions: object;


  /* @ngInject */
  constructor(private $timeout: ITimeoutService, private planningCommonService: PlanningCommonService) {
    this.actions = {};
  }

  $onInit() {
  }


  onOpen($mdMenu, ev) {

    let routedJobs: boolean = false;
    let hasNotRoutedJobs = false;
    let includedJobs = false;
    let excludedJobs = false;
    let hasLockedJobs = false;

    _.forEach(this.selectedIds, (jobId) => {
      const job = _.find(this.jobs, function (j) {
        return j.id === jobId;
      });

      if (!routedJobs && _.get(job, 'routed')) {
        routedJobs = true;
      }

      if (!_.get(job, 'routed')) {
        hasNotRoutedJobs = true;
      }

      if (!includedJobs && !_.get(job, 'excluded')) {
        includedJobs = true;
      }

      if (!excludedJobs && _.get(job, 'excluded')) {
        excludedJobs = true;
      }

      if (!hasLockedJobs && _.get(job, 'lockedRouteId')) {
        hasLockedJobs = true;
      }
    })

    this.actions = {
      addToDraft: !includedJobs,
      removeFromDraft: !excludedJobs,
      createRoute: !hasLockedJobs,
      assignToRoute: true,
      moveToLeftovers: !hasNotRoutedJobs,
      lock: !hasNotRoutedJobs,
      unlock: hasLockedJobs
    };


    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningJobsActionButton', {
    bindings: {
      isDraft: '<?',
      isDisabled: '<?',
      jobs: '<',
      selectedIds: '<',
      onCreateRoute: '&',
      onAssignToRoute: '&',
      onAddToDraft: '&',
      onRemove: '&',
      onMoveToLeftovers: '&',
      onToggleLockJobs: '&',
      onRemoveBlocked: '&'
    },
    template: require('./planning-jobs-action-button.html').default,
    controller: PlanningJobsActionButtonCtrl
  });
